export interface AppGlobalizationSchema {
    LanguageName: string;
    DistanceUnit: string;
}

const AppGlobalization = (window as any).AppGlobalization as AppGlobalizationSchema
export default AppGlobalization